/* global process */
let base = window._env_.VUE_APP_IMG_FLOW_HOST
export const getImgFlowOrderTable = params => {
  return axios.get(`${base}/read_order_list`, {params})
}
// export const getImgFlowOrderDetail = params => {
//   return axios.get(`${base}/getImgFlowOrderDetail/${params.id}`, {params})
// }
// export const exportImgFlowOrderData = params => {
//   return axios.get(`${base}/exportImgFlowOrderData/${params.id}`, {params})
// }
// export const createImgFlowOrderData = params => {
//   return axios.post(`${base}/createImgFlowOrderData`, params)
// }
// export const updateImgFlowOrderData = params => {
//   return axios.post(`${base}/updateImgFlowOrderData/${params.id}`, params)
// }
// export const deleteImgFlowOrderData = params => {
//   return axios.post(`${base}/deleteImgFlowOrderData/${params.id}`, params)
// }
export const resetImgFlowOrder = params => {
  return axios.post(`${base}/update_order_list/reset_result/${params.id}`, params)
}



// WEBPACK FOOTER //
// ./src/views/img-flow-order/img-flow-order.api.js